import * as React from 'react';
import { classNames } from '../../utils/classnames';
import * as styles from './spinner.less';

export const Spinner = ({ className }: { className?: string }) => (
	<div className={classNames(styles.spinner, className)} />
);
